import type { MenuTreeVo } from "types/openapi/auth";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import { RouterLink } from "vue-router";

export function filterMenus(
  menus: (MenuTreeVo & { crumb?: any[]; iconClass?: string })[],
  parentMenu?: MenuTreeVo & { crumb?: any[] },
): (MenuTreeVo & { crumb?: any[]; iconClass?: string })[] {
  const res: (MenuTreeVo & { crumb?: any[]; iconClass?: string })[] = [];
  menus.forEach((menu) => {
    if (menu.isEnable !== 1) {
      return;
    }
    // 避免与 NMenu MenuOption.icon(Function) 类型冲突
    if (menu.icon != null) {
      menu.iconClass = menu.icon as unknown as string;
    }
    delete (menu as any).icon;
    if (parentMenu) {
      menu.crumb = [...(parentMenu?.crumb || [])];
    } else {
      menu.crumb = [];
    }
    menu.crumb.push(menu);
    if (menu.children?.length) {
      menu.children = filterMenus(menu.children, menu);
    }
    res.push(menu);
    if (!parentMenu && menu.path === "/item") {
      res.push({ type: "divider", key: "divider-item" } as any);
    }
  });
  return res;
}

export function renderMenuLabel(route: MenuTreeVo) {
  if (route?.children?.length) {
    return <div>{route.menuName}</div>;
  }
  return <RouterLink to={{ path: route.path }}>{route?.menuName}</RouterLink>;
}

export function renderIcon(name: string) {
  if (!name) {
    return <i class="w-24px" />;
  }
  return <i class={`iconfont ${name}`} />;
}

/**
 * 解析当前路由应高亮的菜单路径
 * 优先级：meta.activeMenu → 精确匹配 menuMap → 路径回溯查找父菜单
 */
export function resolveActiveMenu(
  route: RouteLocationNormalizedLoaded,
  menuMap: Map<string, MenuTreeVo & { crumb?: any[] }>,
): string {
  const { path, meta } = route;

  // 1. 显式指定（适用于路径与菜单不匹配的场景）
  if (meta.activeMenu) {
    return meta.activeMenu as string;
  }

  // 2. 精确匹配
  if (menuMap.has(path)) {
    return path;
  }

  // 3. 路径回溯：逐级缩短路径查找父菜单
  const segments = path.split("/").filter(Boolean);
  for (let i = segments.length - 1; i > 0; i--) {
    const parentPath = `/${segments.slice(0, i).join("/")}`;
    if (menuMap.has(parentPath)) {
      return parentPath;
    }
  }

  return path;
}
